<template>
  <div class="course-body-container">
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="ps__rail-y"></div>
        <div class="article-body mb-5">
          <PerfectScrollbar
            ref="previewScrollbar"
            @ps-scroll-y="syncScroll('preview')"
            class="scrollbar-content-preview"
          >
            <div class="article-body-right-inner">
              <div
                v-for="(fields, i) in data?.fields?.chapters?.content"
                :key="i"
              >
                <div v-if="fields.nodeType === 'unordered-list'">
                  <ul>
                    <li
                      class="article-body-left-list-items"
                      v-for="(listItem, y) in fields?.content"
                      :key="y"
                    >
                      <div
                        :class="
                          highlightedText.includes(item?.text)
                            ? 'article-body-highlight'
                            : item.bold
                            ? item.link
                              ? 'article-body-right-list-items-link'
                              : 'article-body-right-list-items-bold'
                            : item.link
                            ? 'article-body-right-list-items-link'
                            : 'article-body-right-list-items'
                        "
                        v-for="(item, x) in listBullet(listItem)"
                        :key="x"
                        @click="item.link ? openLink(item.link) : null"
                      >
                        {{ item.text }}
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  :class="
                    highlightedText.includes(fields.content[0]?.value)
                      ? 'article-body-highlight'
                      : fields.content[0]?.marks[0]?.type === 'bold'
                      ? 'article-body-left-title'
                      : fields.content[0]?.value === 'Introduction'
                      ? 'article-body-left-subtitle-top'
                      : 'article-body-left-subtitle'
                  "
                  v-else-if="fields.content[0]?.value"
                >
                  <div>{{ fields.content[0]?.value }}</div>
                </div>
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
      <div class="col-lg-8 col-12">
        <div class="article-body-right">
          <PerfectScrollbar
            ref="mainScrollbar"
            @ps-scroll-y="syncScroll('main')"
            :style="`max-height: ${height}`"
          >
            <div class="article-body-right-inner">
              <div
                v-for="(fields, i) in data?.fields?.paragraphs?.content"
                :key="i"
              >
                <div v-if="fields.nodeType === 'unordered-list'">
                  <ul>
                    <li v-for="(listItem, i) in fields?.content" :key="i">
                      <span
                        :class="
                          item.bold
                            ? item.link
                              ? 'article-body-right-list-items-link'
                              : 'article-body-right-list-items-bold'
                            : item.link
                            ? 'article-body-right-list-items-link'
                            : 'article-body-right-list-items'
                        "
                        v-for="(item, x) in listBullet(listItem)"
                        :key="x"
                        @click="item.link ? openLink(item.link) : null"
                      >
                        {{ item.text }}
                      </span>
                    </li>
                  </ul>
                </div>
                <div
                  v-else-if="fields.nodeType === 'embedded-asset-block'"
                  class="article-body-image"
                >
                  <img
                    :src="images[i]"
                    :alt="
                      imagesPlaceholder[i]
                        ? 'template image'
                        : getImageURL(fields?.data?.target?.sys?.id, i)
                    "
                    class="articles-body-image"
                  />
                </div>
                <div v-else-if="fields.nodeType === 'table'">
                  <v-table class="article-body-right-table">
                    <thead class="article-body-right-table-header">
                      <tr
                        v-for="(tableRow, i) in tableData(
                          fields?.content,
                          'table-header-cell'
                        )"
                        :key="i"
                      >
                        <th
                          class="article-body-right-table-header-cell"
                          v-for="(row, x) in tableRow?.content"
                          :key="x"
                        >
                          {{ row?.content[0]?.content[0]?.value }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(tableRow, i) in tableData(
                          fields?.content,
                          'table-cell'
                        )"
                        :key="i"
                      >
                        <td
                          :class="
                            x === 0
                              ? 'article-body-right-table-col-1'
                              : 'article-body-right-table-cell'
                          "
                          v-for="(row, x) in tableRow?.content"
                          :key="x"
                        >
                          {{ row?.content[0]?.content[0]?.value }}
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
                <div v-else>
                  <div
                    :id="fields.nodeType === 'heading-3' ? 'section-' + i : ''"
                    :class="
                      fields.nodeType === 'paragraph'
                        ? fields.content[0]?.value.includes(` - `)
                          ? 'article-body-right-quote'
                          : 'article-body-right-list-items'
                        : fields.nodeType === 'heading-3'
                        ? 'content-item article-body-right-title'
                        : 'content-item article-body-right-small-title'
                    "
                  >
                    <span v-for="(content, x) in fields.content" :key="x">
                      <span
                        v-if="content?.nodeType === 'hyperlink'"
                        @click="openLink(content?.data?.uri)"
                        class="hyper-link"
                      >
                        {{ content.content[0]?.value }}
                      </span>
                      <span v-else>{{ content?.value }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="data?.fields?.authorDetails"
              class="row article-author-wrapper"
            >
              <div class="col-lg-2 col-12">
                <div
                  v-for="(fields, i) in data?.fields?.authorDetails?.content"
                  :key="i"
                >
                  <div
                    v-if="fields.nodeType === 'embedded-asset-block'"
                    class="articles-author-thumb-wrapper"
                  >
                    <img
                      :src="images[i]"
                      :alt="
                        imagesPlaceholder[i]
                          ? 'template image'
                          : getImageURL(fields?.data?.target?.sys?.id, i)
                      "
                      class="articles-author-thumb"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-10 col-12">
                <div
                  v-for="(fields, i) in data?.fields?.authorDetails?.content"
                  :key="i"
                >
                  <div
                    v-if="fields.nodeType === 'heading-6'"
                    class="article-author-right-subtitle"
                  >
                    {{ fields.content[0]?.value }}
                  </div>
                  <div
                    v-else-if="fields.nodeType === 'heading-5'"
                    class="article-author-right-title"
                  >
                    {{ fields.content[0]?.value }}
                  </div>
                  <div
                    v-else-if="fields.nodeType === 'paragraph'"
                    class="article-author-right-paragraph"
                  >
                    {{ fields.content[0]?.value }}
                  </div>
                </div>
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
export default {
  name: "articleBody",
  props: ["data"],
  data() {
    return {
      panel: [0],
      images: [],
      imagesPlaceholder: [],
      index: 0,
      scrollBarTop: 0,
      scrollBarHeight: 0,
      isSyncing: false,
      highlightedSection: null,
      highlightedText: "",
    };
  },
  computed: {
    width() {
      return window?.screen?.width;
    },
    height() {
      return this.width > 800 ? "40vw" : "200vw";
    },
  },
  mounted() {
    this.setProgress(0);
  },
  methods: {
    ...mapMutations(["setProgress"]),
    getImageURL(assetId, i) {
      if (assetId) {
        this.imagesPlaceholder[i] = true;
        axios
          .get(
            `https://cdn.contentful.com/spaces/8nqnktj51aoq/assets/${assetId}?access_token=njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k`
          )
          .then((response) => {
            this.images[i] = `https:${response.data.fields.file.url}`;
          });
      }
    },
    listBullet(item) {
      const content = item?.content[0]?.content;
      let listItem = [];
      content.forEach((item) => {
        listItem.push({
          bold: item.marks?.length > 0,
          text:
            item.nodeType === "hyperlink"
              ? item?.content?.map((cont) => cont.value).join(" ")
              : item.value,
          link: item?.data?.uri,
        });
      });
      return listItem;
    },
    openLink(link) {
      window
        .open(
          `${
            link.includes("mail")
              ? ""
              : link.includes("https")
              ? ""
              : "https://"
          }${link}`,
          "_blank"
        )
        .focus();
    },
    tableData(data, type) {
      const rows = [];
      let cells = [];
      data.forEach((row) => {
        row.content.forEach((tableRow) => {
          if (tableRow.nodeType === type) {
            cells.push(tableRow);
          }
        });
        if (cells.length > 0) {
          rows.push({ content: cells });
        }
        cells = [];
      });
      return rows;
    },
    onScrollEvent(event) {
      this.scrollBarTop = event?.target?.scrollTop;
      this.scrollBarHeight = event?.target?.scrollHeight;
    },
    syncScroll(source) {
      if (this.isSyncing) return; // Avoid triggering sync on both scrolls
      this.isSyncing = true;

      const mainEl = this.$refs.mainScrollbar.$el;
      const previewEl = this.$refs.previewScrollbar.$el;
      if (source === "main") {
        // Sync preview scrollbar to match main scrollbar's scroll position
        const percentage =
          mainEl.scrollTop / (mainEl.scrollHeight - mainEl.clientHeight);
        const progress = Math.ceil(percentage * 100);
        if (progress <= 100) {
          this.setProgress(progress);
        }
        previewEl.scrollTop =
          percentage * (previewEl.scrollHeight - previewEl.clientHeight);
        this.updateHighlightedSection(mainEl.scrollTop);
      } else {
        // Sync main scrollbar to match preview scrollbar's scroll position
        // const percentage =
        //   previewEl.scrollTop /
        //   (previewEl.scrollHeight - previewEl.clientHeight);
        // mainEl.scrollTop =
        //   percentage * (mainEl.scrollHeight - mainEl.clientHeight);
      }

      this.isSyncing = false;
    },
    updateHighlightedSection(scrollTop) {
      // Determine the section to highlight based on the scrollTop position
      const contentItems =
        this.$refs.mainScrollbar.$el.querySelectorAll(".content-item");

      contentItems.forEach((item, index) => {
        const itemTop = item.offsetTop;
        const itemBottom = itemTop + item.clientHeight;
        if (scrollTop >= itemTop && scrollTop < itemBottom) {
          this.highlightedText = item.innerText;
          this.highlightedSection = index + 1; // Update the highlighted section number
        }
      });
    },
  },
};
</script>

<style></style>
